/* unplugin-vue-components disabled */import { render } from "./NewEcharts.vue?vue&type=template&id=016dedf6"
import script from "./NewEcharts.vue?vue&type=script&lang=js"
export * from "./NewEcharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__